var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_949_342)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5394 12.3714C21.082 12.3714 20.7109 12.0007 20.7109 11.5429V9.99679C20.7109 9.53905 21.082 9.16833 21.5394 9.16833C21.9971 9.16833 22.3678 9.53905 22.3678 9.99679V11.5429C22.3678 12.0007 21.9971 12.3714 21.5394 12.3714Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0335 24.4854H3.40085L1.65045 10.483C1.594 10.0292 1.17978 9.70701 0.725638 9.76382C0.271859 9.82027 -0.0503167 10.2345 0.00649552 10.6886L1.8475 25.4167C1.89928 25.8313 2.25166 26.1423 2.66948 26.1423H4.14624L2.40448 36.5918C2.32933 37.0434 2.63424 37.4702 3.0855 37.5454C3.53712 37.6205 3.96394 37.3156 4.03909 36.8643L5.82615 26.1423H10.0335C10.4912 26.1423 10.8619 25.7712 10.8619 25.3138C10.8619 24.8565 10.4912 24.4854 10.0335 24.4854Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.274 9.76382C42.8199 9.70701 42.406 10.0292 42.3492 10.483L40.5988 24.4854H33.9661C33.5088 24.4854 33.1377 24.8565 33.1377 25.3138C33.1377 25.7712 33.5088 26.1423 33.9661 26.1423H38.1738L39.9609 36.8643C40.0404 37.3113 40.4647 37.6108 40.9127 37.5364C41.3604 37.4616 41.6646 37.0405 41.5952 36.5918L39.8534 26.1423H41.3302C41.748 26.1423 42.1004 25.8313 42.1521 25.4167L43.9931 10.6886C44.05 10.2345 43.7278 9.82063 43.274 9.76382Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1655 40.41L26.1508 40.4172C22.8377 42.1424 18.8907 42.1396 15.5797 40.41C13.2914 42.0597 10.2056 42.0648 7.91189 40.423L7.89355 40.41L11.5213 20.0946C11.5526 19.9188 11.7054 19.7908 11.8837 19.7908H32.1624C32.3412 19.7908 32.494 19.9188 32.5253 20.0946L36.1073 40.41L35.8078 40.5693C32.7823 42.1874 29.1359 42.127 26.1655 40.41Z",
    fill: "#CDC6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5794 41.2385C15.1221 41.2385 14.751 40.8674 14.751 40.4101V32.4937C14.751 32.0364 15.1221 31.6653 15.5794 31.6653C16.0372 31.6653 16.4079 32.0364 16.4079 32.4937V40.4101C16.4079 40.8674 16.0372 41.2385 15.5794 41.2385Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1654 41.2385C25.708 41.2385 25.3369 40.8674 25.3369 40.41V29.2719C25.3369 28.8146 25.708 28.4435 26.1654 28.4435C26.6231 28.4435 26.9938 28.8146 26.9938 29.2719V40.41C26.9938 40.8674 26.6231 41.2385 26.1654 41.2385Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0313 12.5746C24.2148 10.7584 21.4828 10.2151 19.1096 11.1982C16.7361 12.1812 15.1888 14.4972 15.1885 17.066C15.1885 17.5237 15.5596 17.8945 16.0169 17.8945H27.063C27.5207 17.8945 27.8914 17.5237 27.8914 17.066C27.8957 15.3807 27.2262 13.7637 26.0313 12.5746Z",
    fill: "#FF8C21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3011 8.92884C23.8437 8.92884 23.4727 8.55777 23.4727 8.10039V5.98324C23.4727 5.52586 23.8437 5.15479 24.3011 5.15479C24.7588 5.15479 25.1296 5.52586 25.1296 5.98324V8.10039C25.1296 8.55777 24.7588 8.92884 24.3011 8.92884Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5277 7.36402C20.0703 7.36402 19.6992 6.99294 19.6992 6.53557V3.22176C19.6992 2.76439 20.0703 2.39331 20.5277 2.39331C20.9854 2.39331 21.3561 2.76439 21.3561 3.22176V6.53557C21.3561 6.99294 20.9854 7.36402 20.5277 7.36402Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0296 9.57322C16.5722 9.57322 16.2012 9.20214 16.2012 8.74476V6.99581C16.2012 6.53844 16.5722 6.16736 17.0296 6.16736C17.4874 6.16736 17.8581 6.53844 17.8581 6.99581V8.74476C17.8581 9.20214 17.4874 9.57322 17.0296 9.57322Z",
    fill: "#50429B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 10.7328C21.8477 10.722 21.6946 10.7145 21.5399 10.7145C18.0338 10.7184 15.1924 13.5598 15.1885 17.0659C15.1885 17.5233 15.5596 17.8944 16.0169 17.8944H22.0002V10.7328Z",
    fill: "#F18017"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_949_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStore);
export default __webpack_public_path__ + "static/media/in-store.5cf4e8c134056ce936850b4b96e9db99.svg";
export { ForwardRef as ReactComponent };